import {createRoot} from 'react-dom/client'
// Axios
import {Chart, registerables} from 'chart.js'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {ReactQueryDevtools} from '@tanstack/react-query-devtools'

import {AppRoutes} from './app/routing/AppRoutes'

import {AuthProvider} from './app/modules/auth/core/AuthContext'
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import './app.css'
dayjs.extend(LocalizedFormat)

Chart.register(...registerables)

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      cacheTime: Infinity,
      networkMode: 'always',
      keepPreviousData: true,
    },
  },
})
const container = document.getElementById('root')
if (container) {
  createRoot(container).render(
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}

    </QueryClientProvider>
  )
}
